export default function getArchivedContactsFromIntervenants(intervenants) {
  if (Array.isArray(intervenants)) {
    return intervenants.flatMap(intervenant => intervenant.intervenantContacts
      .filter(intervenantContact => intervenantContact.contact.archive));
  }
  return [];
}
